const POPULAR_CATEGORIES_IN_BENDIGO = [
  'Air Conditioning',
  'Electricians',
  'Plumbers',
  'Mechanics',
  'Tree Removal',
  'Blinds',
  'Fencing Contractors',
  'Landscape Supplies',
  'Removalists',
  'Tyres',
  'Kitchen Renovations & Designers',
  'Sheds',
  'Garage Doors',
  'Pest Control',
  'Carpet Cleaning',
  'Roofing Contractors',
  'Auto Electricians',
  'Glass & Glaziers - Repairs & Replacements',
  'Builders',
  'Excavating & Earthmoving Hire',
  'Locksmiths',
  'Funeral Directors',
];

export default POPULAR_CATEGORIES_IN_BENDIGO;
